import React from 'react';

export const MenuSheet = ({
  onViewMemorized,
  onViewFavorites,
  onManageDecks,
  onManageCategories,
  onEditCards,
  onToggleShuffle,
  onToggleStudyMode,
  onToggleAutoAdvance,
  onShowKeyboardHelp,
  onShowImportExport,
  onShowStatistics,
  onShowStudyReminders,
  onShowCardLayoutSettings,
  onColorSchemes,
  onEndSession,
  isShuffled,
  studyMode,
  autoAdvance,
  onClose
}) => {
  return (
    <div className="menu-sheet" onClick={onClose}>
      <div className="menu-content" onClick={(e) => e.stopPropagation()}>
        <button className="menu-item" onClick={onToggleStudyMode}>
          {studyMode === 'flashcard' ? '📇 Mode: Flashcard' : studyMode === 'quiz' ? '🎯 Mode: Quiz' : '⌨️ Mode: Typing'} (Click to cycle)
        </button>
        <button className="menu-item" onClick={onManageDecks}>
          📚 Manage Decks
        </button>
        <button className="menu-item" onClick={onManageCategories}>
          📁 Manage Categories
        </button>
        <button className="menu-item" onClick={onEditCards}>
          ✏️ Edit Cards
        </button>
        <button className="menu-item" onClick={onShowStatistics}>
          📊 Statistics
        </button>
        <button className="menu-item" onClick={onShowStudyReminders}>
          🔔 Study Reminders
        </button>
        <button className="menu-item" onClick={onShowCardLayoutSettings}>
          📐 Card Layout
        </button>
        <button className="menu-item" onClick={onColorSchemes}>
          🎨 Color Schemes
        </button>
        <button className="menu-item" onClick={onEndSession}>
          ⏹️ End Session
        </button>
        <button className="menu-item" onClick={onShowImportExport}>
          💾 Import / Export
        </button>
        <button className="menu-item" onClick={onToggleShuffle}>
          {isShuffled ? '🔄 Order: Shuffled' : '🔀 Order: Sequential'}
        </button>
        <button className="menu-item" onClick={onToggleAutoAdvance}>
          {autoAdvance ? '⏭️ Auto-Advance: ON' : '⏸️ Auto-Advance: OFF'}
        </button>
        <button className="menu-item" onClick={onViewMemorized}>
          ⭐ View Memorized Cards
        </button>
        <button className="menu-item" onClick={onViewFavorites}>
          💛 View Favorite Cards
        </button>
        <button className="menu-item" onClick={onShowKeyboardHelp}>
          ⌨️ Keyboard Shortcuts
        </button>
        <button className="menu-item cancel" onClick={onClose}>
          Cancel
        </button>
      </div>
    </div>
  );
};
